export enum NoticeActionsEnum {
  ADD_NOTICE = 'ADD_NOTICE',
  REMOVE_NOTICE = 'REMOVE_NOTICE',
  REMOVE_ALL_NOTICES = 'REMOVE_ALL_NOTICES',
}
